const UserData =
{
  answers: ['were', 'since'],
}


export default UserData;